import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import Columns from 'components/common/Columns/Columns'
import { ReadMore } from 'components/common/ReadMore'
import logo from './assets/vendorLogo.png'

const AboutStore = ({
  aboutStore: [
    {
      content
    } = {}
  ] = [],
  limit = 300
}) =>
  <Wrapper>
    <Columns width="250px auto" adaptive>
      <VendorLogoWrapper data-at-vendor-logo>
        <Text size={ 16 } weight={ 700 } centered block>WHY CHOOSE</Text>
        <VendorBanner src={ logo } alt="Big o Tire" />
        <Text size={ 16 } weight={ 700 } centered block>SERVICES?</Text>
      </VendorLogoWrapper>
      <HTMLBlock data-at-vendor-description>
        <ReadMore
          data-at-store-about-readmore
          limit={ limit }
          content={ content }
          enableShowLess />
      </HTMLBlock>
    </Columns>
  </Wrapper>

export default AboutStore

AboutStore.type = 'BOTAboutStore'

AboutStore.propTypes = {
  aboutStore: PropTypes.arrayOf(PropTypes.shape()),
  limit: PropTypes.number
}

const Wrapper = styled.div`
  margin: 0 auto;
  line-height: 22px;
  ${Mixin.responsive('padding', '55px 0 55px', '20px 25px')}
  ${Mixin.clearFix()}
`

const VendorLogoWrapper = styled.div`
  text-align: center;
  ${Mixin.responsive('margin-bottom', 0, '25px')}
`

const VendorBanner = styled.img`
  display: inline-block;
  padding: 3px;
`

const HTMLBlock = styled.div`
  padding: 6px 0;
`
